import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthGuardData, createAuthGuard } from 'keycloak-angular';
import { AuthenticationService } from '../services/authentication.service';
import { NotificationService } from '../services/notification.service';

export const companyRestrictionGuard = createAuthGuard<CanActivateFn>(async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot, authData: AuthGuardData) => {
  const router = inject(Router);
  const notificationService = inject(NotificationService);
  const authService = inject(AuthenticationService);

  const currentTenant = authService.getTenant();
  console.log('current tenant', currentTenant);

  const forbiddenTenants = route.data?.['forbiddenTenants'] as string[];
  console.log('forbiddenTenants', forbiddenTenants);

  if(forbiddenTenants?.includes(currentTenant)){
    notificationService.restrictedSection();
    return router.navigate(['']);
  }

  return true;
});
